import { FormattedMessage } from "react-intl"
import { ReactNode } from "react"
import { config } from "../../configuration/app/app-config"

import Button from "@rio-cloud/rio-uikit/Button"
import Card from "@rio-cloud/rio-uikit/Card"

export function ContactForm(): ReactNode {
    return (
        <div className="margin-left-50 margin-right-50 margin-top-10">
            <Card className="display-flex flex-column gap-10 justify-content-center align-items-center min-height-200 shadow-subtle">
                <div className="text-color-dark text-bold text-size-h5 text-center">
                    <FormattedMessage
                        id={"supportDialog.technical.common.text"}/></div>
                <Button
                    iconRight
                    variant={Button.VARIANT_LINK}
                    bsStyle='muted'
                    className='text-color-primary text-bold text-size-h2'
                    iconName='rioglyph-new-window'
                    onClick={() => window.open(config.contactForm.url, "blank")}
                >
                    <FormattedMessage id={"supportDialog.button.vwSupport"}/>
                </Button>
                <div className="text-color-gray text-center mt-5">
                    <FormattedMessage
                        id={"supportDialog.technical.common.disclaimer"} values={{
                            _newLine: <br/>
                        }}/></div>
            </Card>
        </div>
    )
}
